import React, { useEffect, useState } from "react";
import "98.css";
import "./SystemMessage.css";

const ApeCoinWindow = () => {
  const [price, setPrice] = useState(null);
  const [change, setChange] = useState(null);

  useEffect(() => {
    fetch("https://api.coingecko.com/api/v3/coins/apecoin")
      .then((res) => res.json())
      .then((data) => {
        const usdData = data.market_data.current_price.usd;
        const change24h = data.market_data.price_change_percentage_24h;
        setPrice(usdData.toFixed(4));
        setChange(change24h.toFixed(2));
      });
  }, []);

  return (
    <div className="window ape-window">
      <div className="title-bar">
        <div className="title-bar-text">System message</div>
        <div className="title-bar-controls">
          <button aria-label="Close" />
        </div>
      </div>
      <div className="window-body">
        <div className="logo-section">
          <img
            src="https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg"
            alt="ApeCoin Logo"
            className="logos"
          />
          <div className="coin-info">
            <div className="coin-name">ApeCoin</div> <div className="coin-symbol">APE</div>
           
          </div>
        </div>
        <div className="price-section">
          <div className="price">${price}</div>
          <div
            className="change"
            style={{ color: change < 0 ? "#a22326" : "green" }}
          >
            {change < 0 ? "▼" : "▲"} {change}% (1d)
          </div>
        </div>
        <div className="ok-button-container">
          <button className="ok-button">Ok</button>
         
        </div> <br/>
      </div>
    </div>
  );
};

export default ApeCoinWindow;